import { Routes } from '@/assets/configs'
import { useIsQueryOwner } from '@/hooks'
import { EmtButtonProps, EmtIcon } from 'emt-components-v2'
import { useTranslation } from 'next-i18next'
import React from 'react'
import LinkButton from './LinkButton'
import useCurrentUser from '@/hooks/useCurrentUser'

type Props = EmtButtonProps

const CertifyButton: React.FC<Props> = (props) => {
  const { t } = useTranslation('common')
  const [, , appendQueryType] = useIsQueryOwner(true)

  const { isPremium, isCertified } = useCurrentUser()

  if (!isPremium || isCertified) {
    return null
  }

  return (
    <LinkButton
      fullWidth
      color="success"
      startIcon={<EmtIcon className="emt-id" />}
      href={appendQueryType(Routes.IDCheck.Base)}
      {...props}
    >
      {t('certify')}
    </LinkButton>
  )
}

export default CertifyButton
